import { render, staticRenderFns } from "./menucoms.vue?vue&type=template&id=741f5b7e&scoped=true"
import script from "./menucoms.vue?vue&type=script&lang=js"
export * from "./menucoms.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "741f5b7e",
  null
  
)

export default component.exports